import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import { injectIntl } from 'react-intl';

const AdminRecipeRow = ({ recipe, getRecipes, intl }) => {
  const image = recipe.image ? <img src={recipe.image.thumbnailImage} alt={recipe.name + ' image'} /> : '';

  function deleteRecipe() {
    const confirmMessage = intl.formatMessage({ id: 'recipe.view.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      apiCalls
        .deleteRecipe(recipe.id)
        .then(() => {
          getRecipes();
        })
        .catch((errors) => {
          window.alert(utils.getErrorMessageFromResponse(errors, true));
        });
    }
  }

  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/recipes/${recipe.id}`} className="link">
          {recipe.id}
        </Link>
      </th>
      <td className="admin-user__image">
        <Link to={`/admin/recipes/${recipe.id}`}>{image}</Link>
      </td>
      <td>
        <div>{recipe.name}</div>
        {recipe.userLink ? (
          <div className="text-muted text-small">
            <a target="_blank" className="link" href={recipe.userLink.url}>
              {recipe.userLink.url}
            </a>
          </div>
        ) : (
          ''
        )}
      </td>
      <td>{recipe.isPrivate ? 'Hidden' : 'Visible'}</td>
      <td>
        #{recipe.chef.id} {recipe.chef.name}
      </td>
      <td>
        <Link to={`/admin/recipes/edit/${recipe.id}`} className="link">
          Edit
        </Link>
        <br />
        <button className="btn btn-normal-link" onClick={deleteRecipe}>
          Delete
        </button>
        <br />
      </td>
    </tr>
  );
};

AdminRecipeRow.propTypes = {
  recipe: PropTypes.object.isRequired,
  getRecipes: PropTypes.func.isRequired,
};

AdminRecipeRow.defaultProps = {};

export default injectIntl(AdminRecipeRow);
